module.exports = __webpack_public_path__ + "static/media/LK_Search.0e58baaf.svg";